import { api } from "@/lib/api-client"

export type FlowCreationPolicy = "everyone" | "restricted"

export type FlowCreationPolicyResponse = {
  policy: FlowCreationPolicy
}

export async function getFlowCreationPolicy(): Promise<FlowCreationPolicyResponse> {
  const response = await api.get("/admin/flows/creation-policy")
  return response.data || response
}

export async function updateFlowCreationPolicy(
  policy: FlowCreationPolicy
): Promise<FlowCreationPolicyResponse> {
  const response = await api.put("/admin/flows/creation-policy", { policy })
  return response.data || response
}

export type FlowEmailBranding = {
  name: string | null
  logo_url: string | null
}

export async function getFlowEmailBranding(): Promise<FlowEmailBranding> {
  const response = await api.get("/admin/flows/email-branding")
  return response.data || response
}

export async function updateFlowEmailBranding(
  branding: FlowEmailBranding
): Promise<FlowEmailBranding> {
  const response = await api.put("/admin/flows/email-branding", branding)
  return response.data || response
}

export type FlowEmailConfig = {
  enabled: boolean
  tenant_id: string
  client_id: string
  client_secret: string | null
  sender_email: string
  recipients: string[]
  recipient_allowlist: string[]
  secret_configured: boolean
  credentials_configured: boolean
  credential_source: "admin" | "app_config" | null
  channel_configured: boolean
}

export type FlowEmailConfigUpdate = {
  enabled: boolean
  tenant_id: string
  client_id: string
  client_secret?: string | null
  sender_email: string
  recipients: string[]
  recipient_allowlist: string[]
}

export type FlowEmailConfigVerifyRequest = {
  tenant_id?: string | null
  client_id?: string | null
  client_secret?: string | null
}

export type FlowEmailConfigVerifyResult = {
  secretValid: boolean
  tokenValid: boolean
  error?: string
}

export async function getFlowEmailConfig(): Promise<FlowEmailConfig> {
  const response = await api.get("/admin/flows/email-config")
  return response.data || response
}

export async function updateFlowEmailConfig(
  config: FlowEmailConfigUpdate
): Promise<FlowEmailConfig> {
  const response = await api.put("/admin/flows/email-config", config)
  return response.data || response
}

export async function verifyFlowEmailConfig(
  config: FlowEmailConfigVerifyRequest
): Promise<FlowEmailConfigVerifyResult> {
  const response = await api.post("/admin/flows/email-config/verify", config)
  return response.data || response
}

export async function testFlowEmailConfig(recipient: string): Promise<{ success: boolean }> {
  const response = await api.post("/admin/flows/email-config/test", { recipient })
  return response.data || response
}
